import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-3aa5831c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "登录", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_LoginDialogMobile = _resolveComponent("LoginDialogMobile");
  var _component_LoginDialogAccount = _resolveComponent("LoginDialogAccount");
  var _component_a_tab_pane = _resolveComponent("a-tab-pane");
  var _component_a_tabs = _resolveComponent("a-tabs");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.loginService.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.loginService.visible = $event;
    }),
    closable: _ctx.props.showCloseBtn,
    "destroy-on-close": true,
    "mask-closable": false,
    keyboard: false,
    width: 432,
    title: null,
    footer: null,
    "body-style": {
      padding: _ctx.specialActiveFlag ? '0 35px 34px 35px' : '0 52px 34px 52px'
    },
    class: _normalizeClass([{
      'show-shadow': !_ctx.props.showCloseBtn
    }, "login-dialog"])
  }, {
    default: _withCtx(function () {
      return [_ctx.SHOW_BRAND ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_1, _createVNode(_component_LoginDialogMobile)], 64)) : (_openBlock(), _createBlock(_component_a_tabs, {
        key: 1,
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.activeKey = $event;
        }),
        centered: "",
        class: "tabs-wrap"
      }, {
        default: _withCtx(function () {
          return [!_ctx.specialActiveFlag ? (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: "2",
            tab: "账号密码登录"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_LoginDialogAccount, {
                itemData: _ctx.itemDetailData
              }, null, 8, ["itemData"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.specialActiveFlag ? (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: "3",
            tab: "专项赛登录"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_LoginDialogAccount, {
                platform: _ctx.specialActiveType
              }, null, 8, ["platform"])];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["activeKey"]))];
    }),
    _: 1
  }, 8, ["visible", "closable", "body-style", "class"]);
}